import { render } from "./LenaSisFormT.vue?vue&type=template&id=cc3c2832"
import script from "./LenaSisFormT.vue?vue&type=script&lang=js"
export * from "./LenaSisFormT.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__